module.exports = __webpack_public_path__ + "img/chevron-down.7e5468b3.svg";